import Heading from 'components/atoms/Heading';
import { useGetDashboardOverviewQuery } from 'redux/api/vehicleIncidents';
import { TailSpin } from 'react-loader-spinner';
import Text from 'components/atoms/Text';
import DashboardIncidentsOverviewLayout from '../DashboardIncidentsOverviewLayout';
import { firstDayOfLastJuly } from 'utils/firstDayOfLastJuly';
import { formatDate } from 'utils/formatDate';
import { IIncidentCategoryBreakdownFilters } from 'types/VehicleIncidents';
import { useAppSelector } from 'redux/hooks';
import { hasAccess } from 'utils/permissions';
import { useState } from 'react';

export interface IDashboardIncidentsOverview {}

const DashboardIncidentsOverview: React.FC<
	IDashboardIncidentsOverview
> = () => {
	const fromDate = firstDayOfLastJuly();
	const filters: IIncidentCategoryBreakdownFilters = {
		dateFrom: formatDate(fromDate),
	};
	const { data } = useGetDashboardOverviewQuery(filters);
	const userPermission = useAppSelector((state) => state.user.permissions);
	const isAdminManager = hasAccess(userPermission, 'admin-manager');
	const [updatedTime, setUpdatedTime] = useState<string>('--:--');

	return (
		<div>
			<Heading type="h1" className="mb-6">
				INCIDENTS OVERVIEW
			</Heading>
			{data ? (
				<>
					<div>
						<Heading type="h3" className="tracking-wide mb-2">
							{data.states.join(', ')}
						</Heading>
						<Text className="text-[14px]">
							{data.branches.map((branch) => branch.name).join(', ')}
						</Text>
					</div>
					<DashboardIncidentsOverviewLayout
						data={data}
						isAdminManager={isAdminManager}
						updatedTime={updatedTime}
						setUpdatedTime={setUpdatedTime}
						dateFrom={filters.dateFrom}
					/>
				</>
			) : (
				<div className="flex flex-col justify-center h-full">
					<TailSpin
						height="25"
						width="25"
						ariaLabel="tail-spin-loading"
						color="#FE9F00"
						wrapperClass="flex mt-2"
						radius={2}
						visible
					/>
				</div>
			)}
		</div>
	);
};

export default DashboardIncidentsOverview;
